import CommandProcessorLib, {
    CommandInstanceType,
    CommandResult,
} from '@terragotech/gen5-command-processing-lib';
import { Gen5Config } from '@terragotech/gen5-config-lib';

export const processCommand = async (
  gen5config: Gen5Config,
  offlineDataLookup: any,
  offlineProximityLookup: any,
  offlineUserLookup: any,
  command: CommandInstanceType,
  advancedSearch: any
): Promise<CommandResult> => {
  const commandProcessor: CommandProcessorLib = new CommandProcessorLib({
    OFFLINE_ATTRIB_LOOKUP: offlineDataLookup,
    ONLINE_ATTRIB_LOOKUP: offlineDataLookup,
    ADVANCED_SEARCH: advancedSearch,
    OFFLINE_PROXIMITY_LOOKUP: offlineProximityLookup,
    ONLINE_PROXIMITY_LOOKUP: offlineProximityLookup,
    OFFLINE_USER_LOOKUP: offlineUserLookup,
    ONLINE_USER_LOOKUP: offlineUserLookup,
  });

  commandProcessor.initfromGen5Config(gen5config);

  return await commandProcessor.processCommand(command);
};